import { createRoot } from "react-dom/client";

// third party
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// project imports
// import * as serviceWorker from 'serviceWorker';
import App from "App";
import { store } from "store";

// style + assets
import "assets/scss/style.scss";
import config from "./config";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import ReportWebVitals from './reportWebVitals';

// Define a global truncation method for numbers to avoid rounding issues
Number.prototype.truncateDecimal = function (decimalCount = 2) {
  if (this === null || this === undefined || isNaN(this)) {
    return (0).toFixed(decimalCount);
  }
  const numStr = this.toString();
  if (numStr.includes("e")) {
    return this.toFixed(decimalCount);
  }
  const re = new RegExp(`^-?\\d+(?:\\.\\d{0,${decimalCount}})?`);
  const match = numStr.match(re);
  if (match) {
    return Number(match[0]).toFixed(decimalCount);
  }
  return (0).toFixed(decimalCount);
};

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <BrowserRouter basename={config.basename}>
      <App />
    </BrowserRouter>
  </Provider>,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Re-register with onUpdate to force strict cache clearing on new builds
serviceWorkerRegistration.register();

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
